import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

const freeConsultationText = css`
  margin-bottom: 8px;
`;

type FreeConsultationProps = {
  onConsultationSignupBtnClick: () => void;
};

export const FreeConsultation = ({ onConsultationSignupBtnClick }: FreeConsultationProps) => (
  <>
    <ModalHeader title="Бесплатная консультация и&nbsp;замер" />
    <ModalContent>
      <Typography className={freeConsultationText} variant="m" size="body_long">
        Оставьте заявку, и&nbsp;мы&nbsp;расскажем обо всех возможностях, запишем на&nbsp;замер
        и&nbsp;подготовим расчёт. Вернём деньги за&nbsp;замер&nbsp;&mdash; просто реализуйте свой проект
        с&nbsp;нами, заказав у&nbsp;нас дверь и&nbsp;установку.
      </Typography>
      <Typography variant="m" size="body_long">
        Будем рядом на&nbsp;всех этапах, от&nbsp;выбора дизайна до&nbsp;производства и&nbsp;установки.
        Поддерживать связь сможем по&nbsp;телефону, в&nbsp;мессенджере или в&nbsp;одном из&nbsp;наших
        магазинов&nbsp;&mdash; как вам удобно.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementText="Оставить заявку"
        elementName="Бесплатная консультация и замер"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
